module.exports = __webpack_public_path__ + "static/img/pic_logon_step2@2x.7bca288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/creatorProcess/pic_logon_step2@2x.png
// module id = Wc/K
// module chunks = 0